import { Component } from '@angular/core';

@Component({
  selector: 'app-taker-admin',
  templateUrl: './taker-admin.component.html',
  styleUrls: ['./taker-admin.component.css']
})
export class TakerAdminComponent  {
}
